module.exports = __webpack_public_path__ + "static/dropdown-menu-48569affdbbc1569a40f4b2d317981c1.png";